import { Empty } from 'antd';
import * as React from 'react';
import { useMemo } from 'react';
import { useTreeReferencesContext } from '../../../../../../../tree/references/TreeReferencesContext';
import { ExpressionReferenceInput } from '../../../../../../expressions/references/input/ExpressionReferenceInput';
import { isReferencePathParent } from '../../../../../../expressions/references/isReferencePathParent';
import { WidgetType } from '../../../../../Widget';
import { ButtonActionContainer } from '../style/ButtonActionContainer';

export interface IButtonActionListRemoveConfigProps {
  name: string;
}

export function ButtonActionListRemoveConfig(
  props: IButtonActionListRemoveConfigProps,
) {
  const { references, root } = useTreeReferencesContext();

  const componentName = useMemo(() => {
    return `${props.name}.listReference`;
  }, [props.name]);

  if (!root) return null;

  return (
    <ButtonActionContainer name="Rimuovi dalla lista">
      <ExpressionReferenceInput
        width="100%"
        references={references}
        name={componentName}
        config={{
          filter: ref =>
            ref.widgetType === WidgetType.Repeatable &&
            isReferencePathParent(ref),
        }}
        notFoundContent={
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Questo widget non è contenuto in nessuna Lista"
          />
        }
      />
    </ButtonActionContainer>
  );
}
